import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const TagSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_10597_1903" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_10597_1903)">
      <path
        d="M1 21V16H3V19H6V21H1ZM18 21V19H21V16H23V21H18ZM4 18V6H6V18H4ZM7 18V6H8V18H7ZM10 18V6H12V18H10ZM13 18V6H16V18H13ZM17 18V6H18V18H17ZM19 18V6H20V18H19ZM1 8V3H6V5H3V8H1ZM21 8V5H18V3H23V8H21Z"
        fill="#0E0E0E"
      />
    </g>
    <rect width="10" height="10" transform="translate(13 12)" fill="white" />
    <path
      d="M18.1473 16.5753L19.8632 14.8594C20.0211 14.7015 20.2771 14.7015 20.435 14.8594C20.5929 15.0173 20.5929 15.2733 20.435 15.4312L18.7192
       17.1471L20.435 18.863C20.5929 19.0209 20.5929 19.2769 20.435 19.4348C20.2771 19.5927 20.0211 19.5927 19.8632 19.4348L18.1473 17.7189L16.4315
        19.4348C16.2736 19.5927 16.0175 19.5927 15.8596 19.4348C15.7017 19.2769 15.7017 19.0209 15.8596 18.863L17.5755 17.1471L15.8596 15.4312C15.7017
         15.2733 15.7017 15.0173 15.8596 14.8594C16.0175 14.7015 16.2736 14.7015 16.4315 14.8594L18.1473 16.5753Z"
      fill="#C92323"
    />
  </svg>
);

const Tag = (props: IIconProps) => <Icon component={TagSvg} {...props} />;

export default Tag;
